var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"hammer",rawName:"v-hammer:tap",value:(function () { return _vm.openFancybox(); }),expression:"() => openFancybox()",arg:"tap"}],staticClass:"form-btn-base form-btn-themed",domProps:{"innerHTML":_vm._s(_vm.html)}})}
var staticRenderFns = []

export { render, staticRenderFns }